import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import { useTableManager } from "~/managers/use-table-manager";
import { useUnsavedChanges } from "~/providers/unsaved-changes-provider";
import { useTableStore } from "~/stores/use-table-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import TableCombinationForm from "./table-combination-form";

export default function TableCombinationDialog() {
  const {
    tableCombinationDialogOpen,
    setTableCombinationDialogOpen,
    currentTableCombination,
    setCurrentTableCombination,
  } = useTableStore();

  const { deleteTableCombination } = useTableManager();

  const { checkUnsavedChanges } = useUnsavedChanges();

  const { t } = useTranslation("common");

  const handleDialog = (open: boolean, force?: boolean) => {
    if (open === false) {
      if (force !== true) {
        const result = checkUnsavedChanges();
        if (result === true) {
          setTableCombinationDialogOpen(true);
          return;
        }
      }
      setCurrentTableCombination(undefined);
    }
    setTableCombinationDialogOpen(open);
  };

  const handleDelete = async () => {
    if (!currentTableCombination) return;
    const result = await deleteTableCombination(currentTableCombination.id);
    if (result === true) {
      handleDialog(false);
    }
  };

  return (
    <Dialog open={tableCombinationDialogOpen} onOpenChange={handleDialog}>
      <DialogContent className="max-w-lg w-full">
        <DialogHeader>
          <DialogTitle>
            {currentTableCombination
              ? t("TableCombinations.title")
              : t("TableCombinations.new_table_combination")}
          </DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <div className="max-h-[80vh] p-4 overflow-auto small-scrollbar">
          <TableCombinationForm
            onClose={(force) => handleDialog(false, force)}
            tableCombination={currentTableCombination}
          />
        </div>
        <DialogFooter>
          {currentTableCombination && (
            <Button
              onClick={handleDelete}
              variant="destructive"
              className="w-full"
            >
              {t("delete")}
            </Button>
          )}
          <Button
            form="table-combination-form"
            variant="success"
            className="w-full"
            type="submit"
          >
            {currentTableCombination
              ? t("TableCombinations.update")
              : t("TableCombinations.create")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
